//include 10
jQuery(function(){
    $("body").on("click",".open-barrierfree-filters", function(event){
        event.preventDefault();
        $(".barrierfree-filter-group").toggle();
        window.ppComponents.common.showMore(
            $(".barrierfree-filter-group .more-wrapper:not(.active)")
        );
    });
    $("body").on("click",".barrierfree-filter-group .close-group", function(event){
        event.preventDefault();
        $(".barrierfree-filter-group").toggle();
        window.ppComponents.common.showMore(
            $(".barrierfree-filter-group .more-wrapper:not(.active)")
        );
    });

    $("body").on("click", ".barrierfree-filter-group .reset-group", function (e) {
        e.preventDefault();
        var container = $(e.target).closest('.barrierfree-filter-group');
        container.find('input[type="checkbox"]').each(function(){
           var defaultChecked = $(this).data("default") == "checked";
           if(!!defaultChecked){
               this.checked = true;
           }
           else{
                this.checked = false;
           }
        });
    });

});